"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const commonUtils_1 = require("../../../Helpers/commonUtils");
const isConsentGivenForYoutubeCookies = (cookieCategoriesAcceptance) => {
    // By default if there are no cookie acceptance details we treat it like there are no constraints.
    if (!cookieCategoriesAcceptance)
        return true;
    return !!(cookieCategoriesAcceptance.functional && cookieCategoriesAcceptance.marketing);
};
const setAdditionalParams = (params) => {
    const location = window.location;
    params.origin =
        location.origin ||
            `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
    params.enablejsapi = 1;
    return params;
};
const parseMediaType = (result) => {
    if (result.params && result.params.list) {
        result.list = result.params.list;
        delete result.params.list;
    }
    if (result.id && result.params && !result.params.ci) {
        result.mediaType = Youtube.mediaTypes.VIDEO;
    }
    else if (result.list) {
        delete result.id;
        result.mediaType = Youtube.mediaTypes.PLAYLIST;
    }
    else if (result.params && result.params.ci) {
        delete result.params.ci;
        result.mediaType = Youtube.mediaTypes.SHARE;
    }
    else {
        return undefined;
    }
    return result;
};
const parseUrl = (url) => {
    const match = url.match(/(?:(?:v|vi|be|videos|embed|live)\/(?!videoseries)|(?:v|ci)=)([\w\-]{11})/i);
    return match ? match[1] : undefined;
};
const createImageUrl = (baseUrl, vi, params) => {
    const url = `${baseUrl + vi.id}/`;
    const quality = params.imageQuality || Youtube.defaultImageQuality;
    return `${url + quality}.jpg`;
};
const parseParameters = (params, result) => {
    if (params.start || params.t) {
        params.start = (0, commonUtils_1.getTime)(params.start || params.t);
        delete params.t;
    }
    if (params.v === result.id) {
        delete params.v;
    }
    if (params.list === result.id) {
        delete params.list;
    }
    return params;
};
const Youtube = {
    provider: 'youtube',
    alternatives: ['youtu', 'ytimg'],
    defaultFormat: 'long',
    formats: {
        short: (vi, params) => Youtube.createShortUrl(vi, params),
        long: (vi, params) => Youtube.createLongUrl(vi, params),
        embed: (vi, params, cookieCategoriesAcceptance) => Youtube.createEmbedUrl(vi, params, cookieCategoriesAcceptance),
        shortImage: (vi, params) => Youtube.createShortImageUrl(vi, params),
        longImage: (vi, params) => Youtube.createLongImageUrl(vi, params),
    },
    imageQualities: {
        '0': '0',
        '1': '1',
        '2': '2',
        '3': '3',
        DEFAULT: 'default',
        HQDEFAULT: 'hqdefault',
        SDDEFAULT: 'sddefault',
        MQDEFAULT: 'mqdefault',
        MAXRESDEFAULT: 'maxresdefault',
    },
    defaultImageQuality: 'hqdefault', // this.imageQualities.HQDEFAULT
    mediaTypes: {
        VIDEO: 'video',
        PLAYLIST: 'playlist',
        SHARE: 'share',
    },
    isConsentGivenForYoutubeCookies: isConsentGivenForYoutubeCookies,
    parse: (url, params) => {
        let result = {
            params,
            id: parseUrl(url),
        };
        result.params = parseParameters(params, result);
        result = parseMediaType(result);
        return result;
    },
    // Removed duplicate createEmbedUrl implementation
    createShortUrl: (vi, params) => {
        let url = `https://youtu.be/${vi.id}`;
        if (params.start) {
            url += `#t=${params.start}`;
        }
        return url;
    },
    createLongUrl: (vi, params) => {
        let url = '';
        const startTime = params.start;
        delete params.start;
        if (vi.mediaType === Youtube.mediaTypes.PLAYLIST) {
            params.feature = 'share';
            url += 'https://youtube.com/playlist';
        }
        else if (vi.mediaType === Youtube.mediaTypes.VIDEO) {
            params.v = vi.id;
            url += 'https://youtube.com/watch';
        }
        else if (vi.mediaType === Youtube.mediaTypes.SHARE) {
            params.ci = vi.id;
            url += 'https://www.youtube.com/shared';
        }
        if (vi.list) {
            params.list = vi.list;
        }
        url += (0, commonUtils_1.combineParams)({
            params,
        });
        if (vi.mediaType !== Youtube.mediaTypes.PLAYLIST && startTime) {
            url += `#t=${startTime}`;
        }
        return url;
    },
    createEmbedUrl: (vi, params = {}, cookieCategoriesAcceptance) => {
        var _a;
        const domain = Youtube.isConsentGivenForYoutubeCookies(cookieCategoriesAcceptance)
            ? 'youtube.com'
            : 'www.youtube-nocookie.com';
        let url = `//${domain}/embed`;
        if (vi.mediaType === Youtube.mediaTypes.PLAYLIST) {
            params.listType = 'playlist';
        }
        else {
            url += `/${vi.id}`;
            // loop hack
            if (params.loop === '1') {
                params.playlist = vi.id;
            }
        }
        if (vi.list) {
            params.list = vi.list;
        }
        params = Youtube.setAdditionalParams(params);
        url += (0, commonUtils_1.combineParams)({
            params,
        });
        const startTime = (_a = vi['params']) === null || _a === void 0 ? void 0 : _a.start;
        if (vi.mediaType !== Youtube.mediaTypes.PLAYLIST && startTime) {
            url += `&start=${startTime}`;
        }
        return url;
    },
    createImageUrl: (baseUrl, vi, params) => {
        const url = `${baseUrl + vi.id}/`;
        const quality = params.imageQuality || Youtube.defaultImageQuality;
        return `${url + quality}.jpg`;
    },
    createShortImageUrl: (vi, params) => {
        return Youtube.createImageUrl('https://i.ytimg.com/vi/', vi, params);
    },
    createLongImageUrl: (vi, params) => {
        return Youtube.createImageUrl('https://img.youtube.com/vi/', vi, params);
    },
    setAdditionalParams: (params) => {
        const location = window.location;
        params.origin =
            location.origin ||
                `${location.protocol}//${location.hostname}${location.port ? ':' + location.port : ''}`;
        params.enablejsapi = 1;
        return params;
    },
};
exports.default = Youtube;
